import { Box } from '@mui/material';
import React, { createContext, ReactNode, useEffect, useState } from 'react';

export const QuoteFooterContext = createContext<{ container: HTMLDivElement | null; setContainer: (node: HTMLDivElement | null) => void }>({ container: null, setContainer: () => {} });

export type QuoteEditorLifecycle = 'new' | 'saved';

interface QuoteEditorSurfaceProps {
  children: ReactNode;
  lifecycle: QuoteEditorLifecycle;
}

/**
 * Shared quote worksheet boundary. Lifecycle-specific controllers provide the
 * data and actions, while both new and persisted quotes render the same editor
 * surface and shared row implementation inside this boundary.
 */
export default function QuoteEditorSurface({
  children,
  lifecycle
}: QuoteEditorSurfaceProps) {
  const [container, setContainer] = useState<HTMLDivElement | null>(null);
  const [footerHeight, setFooterHeight] = useState(112);
  useEffect(() => {
    const footer = container?.parentElement;
    if (!footer || typeof ResizeObserver === 'undefined') return;
    const observer = new ResizeObserver(() => setFooterHeight(footer.getBoundingClientRect().height));
    observer.observe(footer);
    return () => observer.disconnect();
  }, [container]);
  return (
    <QuoteFooterContext.Provider value={{ container, setContainer }}>
    <Box
      data-testid="shared-quote-editor"
      data-quote-lifecycle={lifecycle}
      sx={{ display: 'contents' }}
    >
      {children}
      <Box aria-hidden="true" sx={{ height: footerHeight }} />
    </Box>
    </QuoteFooterContext.Provider>
  );
}
